import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import routes from 'routes';
import Sidebar from '../../components/navigation/Sidebar';
import BottomNav from '../../components/navigation/BottomNav';

const pageVariants = {
	initial: { opacity: 0, y: 12 },
	animate: { opacity: 1, y: 0, transition: { duration: 0.22, ease: [0.25, 0.46, 0.45, 0.94] as [number, number, number, number] } },
	exit: { opacity: 0, y: -8, transition: { duration: 0.15, ease: 'easeIn' as const } },
};

export default function Dashboard() {
	const location = useLocation();

	const getRoutes = (routes: RoutesType[]): any => {
		return routes.map((route: RoutesType, key: any) => {
			if (route.layout === '/admin') {
				return (
					<Route path={route.layout + route.path} key={key} render={(props) => (
						<motion.div
							key={route.path}
							variants={pageVariants}
							initial="initial"
							animate="animate"
							exit="exit"
							className="w-full"
						>
							{React.createElement(route.component, props)}
						</motion.div>
					)} />
				);
			} else {
				return null;
			}
		});
	};

	document.documentElement.dir = 'ltr';

	// Auth guard: redirect to splash screen if not logged in
	const jwtToken = localStorage.getItem('jwtToken');
	if (!jwtToken) {
		return <Redirect to='/auth/sign-in' />;
	}

	const hideBottomNav = ['/admin/developers', '/admin/woocommerce'].some(r => location.pathname.includes(r));

	return (
		<div className="flex h-screen bg-branded">
			<Sidebar />
			<div className="flex-1 relative">
				<AnimatePresence mode="wait" initial={false}>
					<Switch location={location} key={location.pathname}>
						{getRoutes(routes)}
						<Redirect from='/' to='/admin/dashboard' />
					</Switch>
				</AnimatePresence>
				{!hideBottomNav && <BottomNav />}
			</div>
		</div>
	);
}
